import React from "react";
import {
  Routes,
  Route,
  BrowserRouter as Router,
  Navigate,
} from "react-router-dom";
import { history } from "../helpers/history";
import { isUserLoggedIn } from "../services/utils";

import BookingForm from "../components/BookingForm";
import Home from "../components/Home";
import VerifyOtp from "../components/auth/VerifyOtp";
import Residencies from "../components/Residencies";
import ResidenceDetails from "../components/ResidenceDetails";
import SignUp from "../components/auth/SignUp";
import Login from "../components/auth/Login";
import SearchResidence from "../components/SearchResidence";

function Routess() {
  const user = isUserLoggedIn();

  return (
    <Router history={history}>
      <Routes>
        <Route path="/login" element={user ? <Navigate to="/" /> : <Login />} />
        <Route path="/register" element={user ? <Navigate to="/" /> : <SignUp />}/>
        <Route path="/book" element={user ? <BookingForm /> :   <Navigate to="/login" />}/>
        <Route path="/" element={<Home />} />
        <Route path="/verify" element={user ? <Navigate to="/" /> : <VerifyOtp />} />
        <Route path="/residencies/:id" element={<ResidenceDetails />} />
        <Route path="/residencies" element={<Residencies />} />
        <Route path="/search" element={<SearchResidence />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default Routess;
